import { render, staticRenderFns } from "./borrowAndReturnTableOne.vue?vue&type=template&id=3b38ee54&scoped=true&"
import script from "./borrowAndReturnTableOne.vue?vue&type=script&lang=js&"
export * from "./borrowAndReturnTableOne.vue?vue&type=script&lang=js&"
import style0 from "./borrowAndReturnTableOne.vue?vue&type=style&index=0&id=3b38ee54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38ee54",
  null
  
)

export default component.exports